import React, { Component } from 'react';

import { postJson } from '../../helpers/RequestsHelper'

class Survey1 extends Component {

    state = {
        notes: "",
        canContact: false,
        email: "",
        name: "",
        id: 1,
        localId: ""
    }

    constructor() {
        super()
        this.onSubmit = this.onSubmit.bind(this)
        this.onChange = this.onChange.bind(this)
    }

    componentDidMount() {
        let localId = localStorage.getItem("localId");
        if (!localId) {
            const uint32 = window.crypto.getRandomValues(new Uint32Array(1))[0];
            localId = uint32.toString(16)
            localStorage.setItem("localId", localId);
        }
        this.setState({ localId })
    }

    onSubmit = async (e) => {
        let body = this.state

        const cognitoUser = window.userPool.getCurrentUser()

        if (cognitoUser) {
            //This is done for open surveys
            body.userId = cognitoUser.username
        }

        await postJson(process.env.REACT_APP_SERVER_BASE_URL + "/survey/result", body)

        this.setState({ completed: true })
    }

    onChange = (state) => {
        state.completed = false
        this.setState(state)
    }

    validateEmail(email) {
        if (!email) {
            return true
        }
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    render() {
        return (
            <div>
                <h1>Suggestion box <i className="far fa-lightbulb" style={{ color: "#d01a62" }}></i></h1>
                <br />
                If you could automate one task or process (at or outside of work), what would that be?
                <br />
                <textarea className="form-control w-800" onChange={(e) => this.onChange({ notes: e.target.value })} required={true}></textarea>
                <br />
                <div onChange={(e) => this.onChange({ priority: e.target.value })}>
                    How important is this to you?<br />
                    <input type="radio" name="priority" value="nice" autoComplete="off" /> Nice to have
                <br />
                    <input type="radio" name="priority" value="important" autoComplete="off" /> Important
                <br />
                    <input type="radio" name="priority" value="critical" autoComplete="off" /> Critical
                </div>
                <br />

                <div className="custom-control custom-switch" >
                    <input type="checkbox" className="custom-control-input" id="switch" onChange={(e) => this.onChange({ canContact: e.target.checked })} />
                    <label className="custom-control-label" htmlFor="switch">Would it be OK for us to follow up with you?</label>
                </div>
                <br /><br />

                {this.state.canContact ?
                    <div>
                        Email address
                        <br />
                        {this.validateEmail(this.state.email) ? "" : <small id="errorMessage" className="text-danger">Please enter a valid email address</small>}
                        <input className="form-control w-600"
                            type="email"
                            name="email"
                            autoComplete="email"
                            id="email"
                            onChange={(e) => this.onChange({ email: e.target.value })} />
                        <br />
                        Name
                        <br />
                        <input className="form-control w-600"
                            type="text"
                            name="name"
                            autoComplete="name"
                            id="name"
                            onChange={(e) => this.onChange({ name: e.target.value })} />
                        <br />
                    </div>
                    : ""}
                <br />
                {this.state.completed
                    ? "Thanks!"
                    : <button className="submit-btn" onClick={this.onSubmit} disabled={this.state.notes.trim() == ""}>Submit</button>
                }
            </div>
        )
    }
}

export default Survey1;